import { SimpleFormSelect } from "src/app/components/form/SimpleFormSelect";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import { SimpleModal } from "src/app/components";
import { useGetKeywordData, useThematicsOptions } from "src/app/hooks";
import { KeywordsTransport } from "src/app/transports/keywords";
import { SimpleKeyword, upsertKeywordDTO, upsertKeywordDTOSchema } from "src/app/types/keywords";
import { IActionsModal } from "src/app/types/actionsModal";

const VerifyModalContainer = (props: IActionsModal<SimpleKeyword>) => {
    const { handleClose = () => {}, updateGridOnSave = () => {}, entity } = props;

    const [loadingApi, setLoadingApi] = useState(false);
    const { keywordData, loading } = useGetKeywordData(entity?.id);
    const { thematicsOptions, loading: thematicsLoading } = useThematicsOptions();

    const { formatMessage } = useIntl();
    const handleSubmit = async (_values: upsertKeywordDTO) => {
        setLoadingApi(false);
        try {
            const res = await KeywordsTransport.verify(_values);
            await updateGridOnSave(res, true);
            toast.success(formatMessage({ id: "common.notification.success" }));
            setLoadingApi(false);
            handleClose();
        } catch (error: any) {
            setLoadingApi(false);
            toast.error(formatMessage({ id: "common.notification.error" }));
        }
        setLoadingApi(false);
    };
    return (
        <SimpleModal
            entityName={formatMessage({ id: "common.entity.verifyKeyword" })}
            handleClose={handleClose}
            loading={loadingApi || loading}
            formId="keywordVerify"
            showModal={true}
            buttonConfirmationLabel={formatMessage({ id: "common.action.verified" })}
            modalProps={{ size: "sm" }}
        >
            <>
                {!loading && keywordData && (
                    <Formik
                        initialValues={{ id: keywordData.id, thematicId: keywordData.thematic.id }}
                        validationSchema={upsertKeywordDTOSchema}
                        onSubmit={handleSubmit}
                    >
                        <Form id="keywordVerify">
                            <label className="form-label">
                                {formatMessage({ id: "common.field.keyword" })}
                            </label>
                            <p>{keywordData?.keyword}</p>
                            <SimpleFormSelect
                                name="thematicId"
                                label={formatMessage({ id: "common.field.thematic" })}
                                values={thematicsOptions}
                                isLoading={thematicsLoading}
                            />
                        </Form>
                    </Formik>
                )}
            </>
        </SimpleModal>
    );
};

export default VerifyModalContainer;
